export const TrollStory = {
    level: 9,
    name: 'Troll Queen',
    cpu1Name: 'Uin, Goblin Lord',
    cpu2Name: 'Ghorza, Ork Lord',
    cpu3Name: 'Jul, Troll Queen',
    text: 'There are two queens in the Troll Kingdom? That shouldn\'t be possible.',
    classCss: 'map-troll-ico',
    cpu1: {
        id: 22,
        before: {
            type: 'comics',
            comicsSetting: {
                path: './img/stories/troll/intro/',
                slideNumber: 18
            }
        },
        after: {
            player: {
                type: 'text',
                step: {
                    0: "Victory over the treacherous goblins has been achieved! I think the next battles will be easier.",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'Destroy the totem while I hold off Uin.',
                }
            }
        }
    },
    cpu2: {
        id: 23,
        before: {
            type: 'text',
            step: {
                0: "I already feel my throne. Just a few more small obstacles, and justice will prevail!",
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0: "That was tough, but we did it! Did you see how I hit the orc leader?",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'I think we also need an orcish sword and armor.',
                }
            }
        }
    },
    cpu3: {
        id: 24,
        before: {
            type: 'text',
            step: {
                0: 'It\'s time to crush that impostor, Jul. I\'ll go first, you cover me.',
            }
        },
        after: {
            cpu: {
                type: 'text',
                step: {
                    0: 'We should probably prepare better. Do you want to find some side work in the Arena to earn gems for powerful spells?',
                }
            },
            player: {
                type: 'comics',
                comicsSetting: {
                    path: './img/stories/troll/win/',
                    slideNumber: 8
                }
            }
        },

    },
    cpu4: {
        id: 42,
        before: {
            type: 'text',
            step: {
                0: 'Now there’s going to be a real fight — crowd against crowd, and you need to choose your allies carefully.',
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0: "Another glorious victory of the mighty warrior!",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'You chose weak allies — to win, you need stronger ones.',
                }
            }
        }
    },
}
